import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";
import Image from "next/image";

function ShareCategories(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Share categories</HeaderH1>
      <Text>
        Categories can be shared via a URL. The URL can be reached by anyone
        with access to the link from any webbrowser. You can choose to set the
        access to:
      </Text>
      <Text>
        <span style={{ fontWeight: "600" }}>• Public</span> - Anyone with the
        link can access the page, no login required
      </Text>
      <Text>
        <span style={{ fontWeight: "600" }}>• Invite only</span> - Only added
        users will have access to the page, free/paid account login reqired
      </Text>
      <ImageBlock
        src={"/guide/share_category.png"}
        width={693}
        height={618}
        alt={"Share categories"}
      />
      <Text>
        To start sharing a category go to the category edit modal(click and hold
        a category name for 0.4s and it will open). Then click the globe icon
        and select your sharing options. Finally click share category to create
        the page.
      </Text>
      <ImageBlock
        src={"/guide/share_one_group.png"}
        width={628}
        height={697}
        alt={"Share categories"}
      />
      <Text>
        The shared page will dynamically change layout depending on how many
        groups you share. The page can be shared via QR-code by clicking the
        QR-code button. Point a camera on the generate QR-code and it will open
        up in the mobile browser. To fetch the latest changes to the category
        simply reload the page.
      </Text>
      <NextButton
        cta={"Workspaces"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/workspaces"}
      />
    </>
  );
}

ShareCategories.Layout = SideBar;

export default ShareCategories;
